import React, { Component, Fragment } from "react";
import { Button, Col, Form, InputNumber, Modal, Row, Select, Spin } from "antd";
import QueueAnim from "rc-queue-anim";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import { debounce } from "lodash";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";

import {
	companiesService,
	departmentsService,
	employeesService,
	timeBankMaintenanceService,
} from "../../redux/services";
import { DatePickerWithMask, HourPickerWithMask, UIFormSection, UIInfoBanner, UIPageListing } from "../../components";
import UIKpiCards from "../../components/KpiCards";
import { formatHours } from "../../helpers/hours";

class Index extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isSending: false,
			companies: [],
			companiesIsLoading: false,
			departments: [],
			departmentsIsLoading: [],
			employees: [],
			employeesIsLoading: false,
			optionValue: "",
			preview: null,
			previewIsLoading: false,
		};

		this._axiosCancelCompaniesToken = null;
		this._axiosCancelDepartmentsToken = null;
		this._axiosCancelEmployeesToken = null;
		this._axiosCancelPreviewToken = null;
	}

	fetchCompanies = () => {
		if (this._axiosCancelCompaniesToken) {
			this._axiosCancelCompaniesToken.cancel(
				"Only one request allowed at a time."
			);
		}

		this._axiosCancelCompaniesToken = axios.CancelToken.source();

		this.setState({
			companiesIsLoading: true,
		});

		companiesService
			.getAutocomplete({
				orderBy: "nome:asc",
				cancelToken: this._axiosCancelCompaniesToken.token,
			})
			.then((response) => {
				this.setState({
					companiesIsLoading: false,
					companies: response.data.data,
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					companiesIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchDepartments = (value) => {
		if (this._axiosCancelDepartmentsToken) {
			this._axiosCancelDepartmentsToken.cancel(
				"Only one request allowed at a time."
			);
		}

		this._axiosCancelDepartmentsToken = axios.CancelToken.source();

		// if (value !== undefined && !value.trim().length) {
			// this.setState({
				// departmentsIsLoading: false,
				// departments: [],
			// });

			// return false;
		// }

		this.setState({
			departmentsIsLoading: true,
		});

		let params = {
			...(value ? { search: value } : {}),
			is_active: 1,
			orderBy: "nome:asc",
			cancelToken: this._axiosCancelDepartmentsToken.token,
			empresas_ids: this.form.getFieldValue("empresas").includes("todos")
				? []
				: this.form.getFieldValue("empresas"),
		};

		departmentsService
			.getAutocomplete({
				...params,
			})
			.then((response) => {
				this.setState({
					departmentsIsLoading: false,
					departments: response.data.data,
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					departmentsIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchDepartmentsSearch = debounce(this.fetchDepartments, 500);

	fetchEmployees = (value) => {
		if (this._axiosCancelEmployeesToken) {
			this._axiosCancelEmployeesToken.cancel(
				"Only one request allowed at a time."
			);
		}

		this._axiosCancelEmployeesToken = axios.CancelToken.source();

		// if (value !== undefined && !value.trim().length) {
			// this.setState({
				// employeesIsLoading: false,
				// employees: [],
			// });

			// return false;
		// }

		this.setState({
			employeesIsLoading: true,
		});

		let params = {
			...(value ? { search: value } : {}),
			ativo: 1,
			orderBy: "nome:asc",
			cancelToken: this._axiosCancelEmployeesToken.token,
			empresas_ids: this.form.getFieldValue("empresas").includes("todos")
				? []
				: this.form.getFieldValue("empresas"),
			departamentos_ids: this.form
				.getFieldValue("departamentos")
				.includes("todos")
				? []
				: this.form.getFieldValue("departamentos"),
		};

		employeesService
			.getAutocomplete({
				...params,
			})
			.then((response) => {
				this.setState({
					employeesIsLoading: false,
					employees: response.data.data,
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					employeesIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	fetchEmployeesSearch = debounce(this.fetchEmployees, 500);

	onCompanyChange = (value) => {
		if (value.length > 1 && value.includes("todos")) {
			this.form.setFieldValue(
				"empresas",
				value.filter((item) => item !== "todos")
			);
		}

		this.setState({
			employees: [],
			employeesIsLoading: false,
			departments: [],
			departmentsIsLoading: false,
		});

		this.form.setFieldValue("departamentos", ["todos"]);
		this.form.setFieldValue("funcionarios", ["todos"]);
	};

	onCompanySelect = (value) => {
		if (value === "todos") {
			this.form.setFieldValue("empresas", ["todos"]);
		}
	};

	onDepartmentChange = (value) => {
		if (value.length > 1 && value.includes("todos")) {
			this.form.setFieldValue(
				"departamentos",
				value.filter((item) => item !== "todos")
			);
		}
	};

	onDepartmentSelect = (value) => {
		if (value === "todos") {
			this.form.setFieldValue("departamentos", ["todos"]);
		}
	};

	onEmployeeChange = (value) => {
		if (value.length > 1 && value.includes("todos")) {
			this.form.setFieldValue(
				"funcionarios",
				value.filter((item) => item !== "todos")
			);
		}
	};

	onEmployeeSelect = (value) => {
		if (value === "todos") {
			this.form.setFieldValue("funcionarios", ["todos"]);
		}
	};

	componentDidMount() {
		if (!this.state.companies.length) {
			this.fetchCompanies();
		}
	}

	resetFields = () => {
		this.setState({
			companies: [],
			companiesIsLoading: false,
			departments: [],
			departmentsIsLoading: false,
			employees: [],
			employeesIsLoading: false,
		});
	};

	doCloseJourney = (data) => {
		this.setState({
			isSending: true,
		});

		// TODO: Verificar se vai ter campo de status
		data.status = true;

		if(data.horas) data.horas = data.horas;

		timeBankMaintenanceService
			.create(data)
			.then((response) => {
				this.setState({
					isSending: false,
				});

				// Reset fields
				this.resetFields();

				Modal.success({
					content: "Ação realizada com sucesso!",
					okText: "Ok",
					onOk: () => {
						return window.location.reload(false);
					},
				});
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	scopeData = (values) => {
		const data = { ...values };

		if (!(data.empresas instanceof Array)) {
			data.empresas = [data.empresas];
		}

		if (!(data.departamentos instanceof Array)) {
			data.departamentos = [data.departamentos];
		}

		if (!(data.funcionarios instanceof Array)) {
			data.funcionarios = [data.funcionarios];
		}

		if (data.empresas.includes("todos")) {
			data.empresas = null;
		}

		if (data.departamentos.includes("todos")) {
			data.departamentos = null;
		}

		if (data.funcionarios.includes("todos")) {
			data.funcionarios = null;
		}

		data.data = moment(data.data).format("YYYY-MM-DD");

		return data;
	};

	onFinish = (values) => {
		const data = this.scopeData(values);

		Modal.confirm({
			content: `Confirma essa ação na data ${moment(data.data).format("DD/MM/YYYY")}?`,
			okText: "Confirmar",
			cancelText: "Cancelar",
			autoFocusButton: null,
			onOk: () => {
				return this.doCloseJourney(data);
			},
		});
	};

	fetchPreview = () => {
		const values = this.form.getFieldsValue();

		if (this._axiosCancelPreviewToken) {
			this._axiosCancelPreviewToken.cancel("Only one request allowed at a time.");
		}

		if (!values.data) {
			this.setState({ preview: null, previewIsLoading: false });

			return;
		}

		this._axiosCancelPreviewToken = axios.CancelToken.source();

		this.setState({ previewIsLoading: true });

		timeBankMaintenanceService
			.getPreview({
				params     : this.scopeData(values),
				cancelToken: this._axiosCancelPreviewToken.token,
			})
			.then((response) => {
				this.setState({
					previewIsLoading: false,
					preview         : response.data,
				});
			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					previewIsLoading: false,
					preview         : null,
				});
			});
	};

	fetchPreviewDebounced = debounce(this.fetchPreview, 600);

	previewKpis = () => {
		const { preview, previewIsLoading } = this.state;
		const hint = previewIsLoading ? "Calculando..." : "Informe a data para ver a prévia";
		const saldo = (minutes) => `${minutes > 0 ? "+" : ""}${formatHours(minutes)}`;

		return [
			{
				key    : "funcionarios",
				tone   : "blue",
				icon   : <i className="fal fa-users" />,
				title  : "Funcionários afetados",
				value  : preview ? preview.funcionarios : null,
				caption: preview ? "Com cartão ponto na data e banco de horas" : hint,
			},
			{
				key    : "atual",
				tone   : preview && preview.saldo_atual < 0 ? "red" : "green",
				icon   : <i className="fal fa-clock" />,
				title  : "Saldo total atual",
				value  : preview ? saldo(preview.saldo_atual) : null,
				caption: preview ? "Soma dos saldos até a data" : hint,
			},
			{
				key    : "apos",
				tone   : "violet",
				icon   : <i className="fal fa-history" />,
				title  : "Saldo após ação",
				value  : preview && this.state.optionValue ? saldo(preview.saldo_apos) : null,
				caption: preview ? (this.state.optionValue ? "Estimativa após a execução" : "Selecione a ação") : hint,
			},
		];
	};

	onActionSelect = (value) => {
		this.setState(
			{
				optionValue: value,
			},
			() => {
				if (value === "descontar_saldo" || value === "lancar_ajuste") {
					this.percentual && this.percentual.focus();
				}
			}
		);
	};

	render() {
		const {
			isSending,
			companies,
			companiesIsLoading,
			departments,
			departmentsIsLoading,
			employees,
			employeesIsLoading,
			optionValue = "0",
		} = this.state;

		return (
			<QueueAnim className="site-content-inner">
				<div className="page-content page-form" key="1">
					<UIPageListing
						icon={<i className="fal fa-business-time" />}
						title="Manutenção do Banco de Horas"
						subtitle="Realize ações e ajustes no banco de horas dos funcionários."
						enableSearch={false}
						showListTypeChange={false}
					>
						<Form
							ref={(el) => (this.form = el)}
							layout="vertical"
							scrollToFirstError
							onFinish={this.onFinish}
							onValuesChange={this.fetchPreviewDebounced}
							initialValues={{
								empresas: ["todos"],
								departamentos: ["todos"],
								funcionarios: ["todos"],
								sinal: "positivo",
							}}
						>
							<UIFormSection
								icon={<i className="fal fa-filter" />}
								title="1. Filtros"
								description="Defina quem entra no escopo da ação."
							>
								<Row gutter={16}>
									<Col xs={24} md={12}>
										<Form.Item
											name="empresas"
											label="Empresa"
											rules={[{ required: true, message: "Campo obrigatório." }]}
										>
											<Select
												ref={(el) => (this.empresas = el)}
												mode="multiple"
												optionFilterProp="children"
												filterOption={(input, option) =>
													(typeof option.children === "string"
														? option.children
														: option.children.props.children
													)
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
												}
												allowClear
												placeholder="Selecione a(s) empresa(s)"
												notFoundContent={
													companiesIsLoading ? (
														<Spin
															indicator={
																<i className="fad fa-spinner-third fa-spin" />
															}
														/>
													) : null
												}
												onChange={this.onCompanyChange}
												onSelect={this.onCompanySelect}
												showSearch
											>
												<Select.Option value="todos">Todas</Select.Option>
												{companies.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.nome}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											name="departamentos"
											label="Departamento"
											rules={[{ required: true, message: "Campo obrigatório." }]}
										>
											<Select
												mode="multiple"
												optionFilterProp="children"
												filterOption={(input, option) =>
													(typeof option.children === "string"
														? option.children
														: option.children.props.children
													)
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
												}
												allowClear
												placeholder="Selecione o(s) departamento(s)"
												notFoundContent={
													departmentsIsLoading ? (
														<Spin
															indicator={
																<i className="fad fa-spinner-third fa-spin" />
															}
														/>
													) : null
												}
												onDropdownVisibleChange={(open) => open && this.fetchDepartments()}
												onSearch={this.fetchDepartmentsSearch}
												onChange={this.onDepartmentChange}
												onSelect={this.onDepartmentSelect}
												showSearch
											>
												<Select.Option value="todos">Todos</Select.Option>
												{departments.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.nome}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											name="funcionarios"
											label="Funcionário"
											rules={[{ required: true, message: "Campo obrigatório." }]}
										>
											<Select
												mode="multiple"
												filterOption={false}
												allowClear
												placeholder="Selecione o(s) funcionário(s)"
												notFoundContent={
													employeesIsLoading ? (
														<Spin
															indicator={
																<i className="fad fa-spinner-third fa-spin" />
															}
														/>
													) : null
												}
												onDropdownVisibleChange={(open) => open && this.fetchEmployees()}
												onSearch={this.fetchEmployeesSearch}
												onChange={this.onEmployeeChange}
												onSelect={this.onEmployeeSelect}
												showSearch
											>
												<Select.Option value="todos">Todos</Select.Option>
												{employees.map((item, index) => (
													<Select.Option key={index} value={item.id}>
														{item.nome}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<DatePickerWithMask
											label="Data"
											extra="Dia em que a ação é lançada no banco de horas."
											name="data"
											required={true}
										/>
									</Col>
								</Row>
							</UIFormSection>
							<UIFormSection
								icon={<i className="fal fa-bolt" />}
								title="2. Ação a ser realizada"
							>
								<Row gutter={16}>
									<Col xs={24} lg={12}>
										<Form.Item
											name="acao"
											label="Ação"
											rules={[{ required: true, message: "Campo obrigatório." }]}
										>
											<Select
												ref={(el) => (this.acao = el)}
												optionLabelProp="label"
												optionFilterProp="label"
												allowClear
												placeholder="Selecione a ação"
												popupClassName="time-bank-action-dropdown"
												showSearch
												onChange={this.onActionSelect}
											>
												<Select.Option value="fechar_banco_hora" label="Fechar banco de horas">
													<div className="time-bank-action-option">
														<strong>Fechar banco de horas</strong>
														<span>Zera o saldo acumulado até a data, lançando um ajuste com o valor do saldo.</span>
													</div>
												</Select.Option>
												<Select.Option value="descontar_saldo" label="Descontar % do saldo">
													<div className="time-bank-action-option">
														<strong>Descontar % do saldo</strong>
														<span>Desconta um percentual do saldo acumulado até a data.</span>
													</div>
												</Select.Option>
												<Select.Option value="lancar_ajuste" label="Lançar ajuste">
													<div className="time-bank-action-option">
														<strong>Lançar ajuste</strong>
														<span>Lança horas positivas ou negativas no banco na data informada.</span>
													</div>
												</Select.Option>
												<Select.Option value="limpar_ajuste" label="Limpar ajuste">
													<div className="time-bank-action-option">
														<strong>Limpar ajuste</strong>
														<span>Remove os ajustes de banco de horas lançados na data informada.</span>
													</div>
												</Select.Option>
											</Select>
										</Form.Item>
										<Row gutter={16}>
										{optionValue === "descontar_saldo" && (
											<Fragment>
												<Col xs={24} md={12}>
													<Form.Item
														name="percentual"
														label="Percentual"
														rules={[{ required: true, message: "Campo obrigatório." }]}
													>
														<InputNumber
															defaultValue={0}
															min={0}
															max={100}
															formatter={(value) => `${value}%`}
															parser={(value) => value.replace('%', '')}
														/>
													</Form.Item>
												</Col>
											</Fragment>
										)}
										{optionValue === "lancar_ajuste" && (
											<Fragment>
												<Col xs={24} md={12}>
													<HourPickerWithMask name="horas" label="Horas" placeholder="Horas" threeDigitMask required={true} />
												</Col>
												<Col xs={24} md={12}>
													<Form.Item
														name="sinal"
														label="Sinal"
														rules={[{ required: true, message: "Campo obrigatório." }]}
													>
														<Select
															optionFilterProp="children"
															filterOption={(input, option) =>
																option.children
																	.toLowerCase()
																	.indexOf(input.toLowerCase()) >= 0
															}
															placeholder="Selecionar sinal"
															style={{ width: "100%" }}
															showSearch
														>
															<Select.Option value="positivo">Positivo</Select.Option>
															<Select.Option value="negativo">Negativo</Select.Option>
														</Select>
													</Form.Item>
												</Col>
											</Fragment>
										)}
										</Row>
									</Col>
									<Col xs={24} lg={12}>
										<UIInfoBanner
											icon={<i className="fal fa-info-circle" />}
											title="Sobre as ações"
											description="As ações são gravadas como ajustes no banco de horas, na data informada, e o cartão ponto do dia é recalculado. Só entram funcionários que têm cartão ponto na data e usam banco de horas."
										/>
									</Col>
								</Row>
							</UIFormSection>
							<UIFormSection
								icon={<i className="fal fa-shield-check" />}
								title="3. Resumo do impacto (prévia)"
								description="Calculado com os filtros, a data e a ação escolhidos."
							>
								<UIKpiCards items={this.previewKpis()} />
							</UIFormSection>
							<UIInfoBanner
								icon={<i className="fal fa-exclamation-triangle" />}
								title="Atenção"
								description="A ação é aplicada a todos os funcionários do escopo de uma vez. Confira a prévia antes de iniciar o processamento."
							/>
							<Button
								type="primary"
								htmlType="submit"
								size="large"
								icon={<i className="far fa-play" />}
								loading={isSending}
								disabled={isSending}
							>
								{isSending ? "Processando" : "Iniciar processamento"}
							</Button>
						</Form>
					</UIPageListing>
				</div>
			</QueueAnim>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
	};
};

export default connect(mapStateToProps)(Index);
